export const appStoreUrl = "https://apps.apple.com/id/app/lion-parcel/id1455977134";
export const playStoreUrl = "https://play.google.com/store/apps/details?id=com.lionparcel.services.consumer&hl=in";

export const getOS = () => {
  let userAgent = window.navigator.userAgent,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;
  
    if (_checkPlatform(macosPlatforms, userAgent)) {
      os = 'Mac OS';
    } else if (_checkPlatform(iosPlatforms, userAgent)) {
      os = 'iOS';
    } else if (_checkPlatform(windowsPlatforms, userAgent)) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (/Linux/.test(userAgent)) {
      os = 'Linux';
    }
  
    return os;
  }
const _checkPlatform = (platforms, userAgent) => {
  let result = [];
  platforms.forEach((platform) => {
    let regex = new RegExp(platform)
    result.push(regex.test(userAgent))
  })

  return result.includes(true)
}

export const isAndroid = () => {
  return getOS() === "Android"
}

export const isIOS = () => {
  return getOS() === "iOS"
}

export const isMac = () => {
  return getOS() === "Mac OS"
}

export const isWindows = () => {
  return getOS() === "Windows"
}

export const isLinux = () => {
  return getOS() === "Linux"
}

export const getStoreUrlByOS = () => {
  return isAndroid() ? playStoreUrl : appStoreUrl;
}
